import withStyles from "@mui/styles/withStyles";
import { Paper, Table, TablePagination } from "@mui/material";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useStyles } from "./AdvTable/tableStyles";
import AdvTableBody from "./AdvTableBody";
import { SelectedAdvSelector } from "./logic/formActions";

const AdvertisementCloneTable = ({ classes }) => {
    const selectedAdv = useSelector(SelectedAdvSelector);
    const [page, setPage] = useState(0);
    const [maxResults, setMaxResults] = useState(25);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setMaxResults(parseInt(event.target.value, 10));
        setPage(0);
    };
    const currentPageData = selectedAdv.slice(page * maxResults, page * maxResults + maxResults);

    return (
        <Paper className={classes.paper}>
            <div className="table-wrapper">
                <Table
                    className={classes.table}
                    aria-labelledby="tableTitle"
                    size={"small"}
                    aria-label="enhanced table"
                >
                    <AdvTableBody
                        customList={currentPageData.map((adv) => adv)}
                        showFilm={true}
                        reducedView
                        showCompany={true}
                        expandAllRows={false}
                        expandFromAllButton={false}
                        onChangeExpanded={() => {}}
                        classes={classes}
                        getSorting={() => {}}
                        page={page}
                        rowsPerPage={maxResults}
                        dense={true}
                    />
                </Table>
            </div>
            <TablePagination
                rowsPerPageOptions={[25, 50, 75, 100]}
                component="div"
                count={selectedAdv.length}
                rowsPerPage={maxResults}
                page={page}
                backIconButtonProps={{
                    "aria-label": "previous page",
                }}
                nextIconButtonProps={{
                    "aria-label": "next page",
                }}
                onPageChange={handleChangePage}
                onRowsPerPageChange={handleChangeRowsPerPage}
            />
        </Paper>
    );
};

export default withStyles(useStyles)(AdvertisementCloneTable);
